const EbookInfo = () => {
  return (
    <div id="Ebook_info">
      <img src="images/Ebook.png" alt="ebook" />
      <h4 id="book_info_text">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat.
      </h4>
    </div>
  );
};

export default EbookInfo;
